import { translate } from '../utils/translation';

import * as constants from './constants';

export function dateToTicks(date) {
  // var d = new Date(); // DateTime.Now
  // d = new Date(d.getTime() - d.getTimezoneOffset() * 60000)    // DateTime.UtcNow

  const epochOffset = 621355968000000000;
  const ticksPerMillisecond = 10000;

  const ticks = date.getTime() * ticksPerMillisecond + epochOffset;

  return ticks;
}

export function dateFromTicks(ticks) {
  const epochOffset = 621355968000000000;
  const ticksPerMillisecond = 10000;

  var millisecond = (ticks - epochOffset) / ticksPerMillisecond;

  return new Date(millisecond);
}

export function dateUtcToLocal(utc) {
  var offset = new Date().getTimezoneOffset();
  return new Date(utc.getTime() + offset * 60000);
}

const extensionToFileTypeMap = (() => {
  const map = {};
  const fileTypeOrder = [
    'Word',
    'Excel',
    'Powerpoint',
    'Pdf',
    'Psd',
    'Audio',
    'Video',
    'Image',
    'Code',
    'Cad',
    'Text',
    'Wopitest',
    'AsposePDF',
  ];

  for (const fileTypeKey of fileTypeOrder) {
    const extensionsStr = constants.SUPPORTED_FILES[fileTypeKey];
    if (!extensionsStr) continue; // Salta se non ci sono estensioni per questo tipo
    const extensions = extensionsStr.split('|');
    for (const ext of extensions) {
      if (ext) {
        const normalizedExt = ext.trim().toLowerCase().replace(/^\./, '');
        map[normalizedExt] = constants.FILE_TYPE[fileTypeKey];
      }
    }
  }
  return map;
})();

export function detectFileType(extension) {
  if (!extension || typeof extension !== 'string') {
    return constants.FILE_TYPE.Unknown;
  }

  // Remove leading dot from extension
  extension = extension.trim().toLowerCase().replace(/^\./, '');

  return extensionToFileTypeMap[extension] || constants.FILE_TYPE.Unknown;
}

export function displayFormattedPrice(price, currency) {
  if (!currency) currency = 'USD';
  return new Intl.NumberFormat(
    currency?.toUpperCase() === 'USD' ? 'en-US' : 'it-IT',
    {
      currency: currency?.toUpperCase(),
      style: 'currency',
    }
  ).format(price);
}

export function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + ' ' + translate('years_ago');
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + ' ' + translate('months_ago');
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + ' ' + translate('days_ago');
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + ' ' + translate('hours_ago');
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + ' ' + translate('minutes_ago');
  }

  return Math.floor(seconds + 1) + ' ' + translate('seconds_ago');
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function formatFileSize(fileSizeInBytes = 0) {
  if (fileSizeInBytes < 1024) {
    return fileSizeInBytes + ' B';
  } else if (fileSizeInBytes < 1024 * 1024) {
    return (fileSizeInBytes / 1024).toFixed(1) + ' KB';
  } else {
    return (fileSizeInBytes / (1024 * 1024)).toFixed(1) + ' MB';
  }
}

export function getIconNameByFileExt(ext) {
  const fileType = detectFileType(ext);
  switch (fileType) {
    case constants.FILE_TYPE.Folder:
      return { color: '#FF9908', icon: 'FolderIcon' };
    case constants.FILE_TYPE.Word:
      return { color: '#0072FF', icon: 'WordFileIcon' };
    case constants.FILE_TYPE.Excel:
      return { color: '#0072FF', icon: 'ExcelFileIcon' };
    case constants.FILE_TYPE.Powerpoint:
      return { color: '#0072FF', icon: 'PptFileIcon' };
    case constants.FILE_TYPE.Pdf:
      return { color: '#FF2116', icon: 'PdfFileIcon' };
    case constants.FILE_TYPE.Wopitest:
    case constants.FILE_TYPE.PreviewConversion:
    case constants.FILE_TYPE.Text:
      return { color: '#0072FF', icon: 'DocumentsFileIcon' };
    case constants.FILE_TYPE.Image:
      switch (ext) {
        case '.ai':
          return { color: '#FF9908', icon: 'AiFileIcon' };
        case '.psd':
          return { color: '#005FAD', icon: 'PsdFileIcon' };
        case '.png':
          return { color: '#005FAD', icon: 'PngFileIcon' };
        case '.gif':
          return { color: '#005FAD', icon: 'GifFileIcon' };
      }
      return { color: '#00C650', icon: 'ImagesFileIcon' };
    case constants.FILE_TYPE.Audio:
      return { color: '#FF3E4C', icon: 'AudioFileIcon' };
    case constants.FILE_TYPE.Video:
      return { color: '#A140FF', icon: 'VideoFileIcon' };
    case constants.FILE_TYPE.Code:
      return { color: '#00C650', icon: 'CodeFileIcon' };
    case constants.FILE_TYPE.Cad:
      return { color: '#E51050', icon: 'CadFileIcon' };
    case '':
      return { color: '#005FAD', icon: 'UnknownFileIcon' };
    default:
      return { color: '#005FAD', icon: 'UnknownFileIcon' };
  }
}

export const getUserInitials = (fullName) => {
  return fullName
    .split(' ')
    .filter((t, i) => i < 2)
    .map((word) => word[0]?.toUpperCase())
    .join('');
};

export const isValidEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const isValidStringInput = (input) => {
  return input && input.trim() !== '';
};

export function objectsEqual(object1, object2) {
  return JSON.stringify(object1) === JSON.stringify(object2);
}

export function trimInputValue(value) {
  return value.trimStart().replace('  ', ' ');
}

// File encryption

export async function readFileContent(file) {
  if (file === null) return;

  const _infoSelectedFile = {};
  _infoSelectedFile.fileSize = file.size;
  _infoSelectedFile.fileName = file.name;
  _infoSelectedFile.fileExtension = file.name.substring(
    file.name.lastIndexOf('.')
  );
  _infoSelectedFile.fileMode = constants.FILE_MODE.NotEncrypted;
  _infoSelectedFile.fileType = detectFileType(_infoSelectedFile.fileExtension);

  const fileBytes = await readFileBytes(file);
  // .then(fileBytes => {
  _infoSelectedFile.fileBytes = new Uint8Array(fileBytes);
  const hash = await getHashFromBytes(_infoSelectedFile.fileBytes, false);
  // .then(hash => {
  _infoSelectedFile.hash = hash;

  if (_infoSelectedFile.fileExtension === '.pdf') {
    const DOCUMENT_TAG_STANDARD = 'www.filegrant.com/encrypted/';
    const DOCUMENT_TAG_PACKAGED = '***filegrant_packaged_';
    const DOCUMENT_TAG_PLACEHOLDER = '@@@filegrant_placeholder_';
    const DOCUMENT_TAG_ID = '@@@filegrant_id_';
    const MAX_BYTES = 10000;
    const MAX_BYTES_END = file.size < MAX_BYTES ? file.size : MAX_BYTES;

    // Check first bytes to see if it is a packaged file
    const firstBytes = file.slice(0, MAX_BYTES);
    const firstPartContent = await readFileTextContent(firstBytes);
    // .then(firstPartContent => {
    if (firstPartContent.includes(DOCUMENT_TAG_PLACEHOLDER)) {
      // Get Extension
      let index = firstPartContent.indexOf(DOCUMENT_TAG_PLACEHOLDER);
      let totalLen = '';
      let cLen;
      do {
        cLen = firstPartContent[index + DOCUMENT_TAG_PLACEHOLDER.length];
        if (cLen !== '_') totalLen += cLen;
        index++;
      } while (cLen !== '_');
      const iLen = parseInt(totalLen);
      _infoSelectedFile.internalUrl = firstPartContent
        .substr(index + DOCUMENT_TAG_PLACEHOLDER.length, iLen)
        .replaceAll('#2F', '/');
    }
    if (firstPartContent.includes(DOCUMENT_TAG_ID)) {
      // Get Extension
      let index = firstPartContent.indexOf(DOCUMENT_TAG_ID);
      let totalLen = '';
      let cLen;
      do {
        cLen = firstPartContent[index + DOCUMENT_TAG_ID.length];
        if (cLen !== '_') totalLen += cLen;
        index++;
      } while (cLen !== '_');
      const iLen = parseInt(totalLen);
      _infoSelectedFile.fileId = firstPartContent.substr(
        index + DOCUMENT_TAG_ID.length,
        iLen
      );
    }
    if (firstPartContent.includes(DOCUMENT_TAG_PACKAGED)) {
      const index = firstPartContent.indexOf(DOCUMENT_TAG_PACKAGED);
      var extLength = parseInt(
        firstPartContent[index + DOCUMENT_TAG_PACKAGED.length].toString()
      );
      _infoSelectedFile.fileExtension = firstPartContent.substr(
        index + DOCUMENT_TAG_PACKAGED.length + 2,
        extLength
      );
      _infoSelectedFile.fileType = detectFileType(
        _infoSelectedFile.fileExtension
      );
      _infoSelectedFile.fileMode = constants.FILE_MODE.Packaged;
      // resolve

      return _infoSelectedFile;
    } else {
      // Check last bytes
      const lastBytes = file.slice(file.size - MAX_BYTES_END);
      const lastPartContent = await readFileTextContent(lastBytes);
      // .then(lastPartContent => {
      if (lastPartContent.includes(DOCUMENT_TAG_STANDARD)) {
        const values = lastPartContent
          .substring(lastPartContent.indexOf(DOCUMENT_TAG_STANDARD))
          .split(/\r?\n/);
        _infoSelectedFile.fileExtension = values[0]
          .split(DOCUMENT_TAG_STANDARD)
          .pop();
        _infoSelectedFile.fileEncryptedProperties = values[1];
        _infoSelectedFile.fileMode = constants.FILE_MODE.Encrypted;
        _infoSelectedFile.fileType = detectFileType(
          _infoSelectedFile.fileExtension
        );
      }
      // resolve

      return _infoSelectedFile;
      // });
    }
    // });
  } else {
    // resolve

    return _infoSelectedFile;
  }
  // });
  // });
}

// readFileBytes ---
function readFileBytes(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (evt) {
      resolve(evt.target.result);
    };
    reader.readAsArrayBuffer(file);
  });
}

function getHashFromBytes(fileBytes, formatHex) {
  return new Promise((resolve) => {
    crypto.subtle.digest('SHA-256', fileBytes).then((buffer) => {
      const hashArray = Array.from(new Uint8Array(buffer));
      if (formatHex) {
        var hashHex = hashArray
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('');
        resolve(hashHex);
      } else {
        var base64 = arrayBufferToBase64(hashArray);
        resolve(base64);
      }
    });
  });
}

function readFileTextContent(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (evt) {
      resolve(evt.target.result);
    };
    reader.readAsText(file);
  });
}

// arrayBufferToBase64 ---
function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

export function isFiltered(currentFilters) {
  return (
    JSON.stringify({
      fileTypes: currentFilters.fileTypes,
      search: currentFilters.search,
      shareFilter: currentFilters.shareFilter,
      shareWith: currentFilters.shareWith,
      statusFilter: currentFilters.statusFilter,
      tags: currentFilters.tags,
      usersRoleFilter: currentFilters.usersRoleFilter,
    }) !==
    JSON.stringify({
      fileTypes: constants.DEFAULT_FILTERS.fileTypes,
      search: constants.DEFAULT_FILTERS.search,
      shareFilter: constants.DEFAULT_FILTERS.shareFilter,
      shareWith: constants.DEFAULT_FILTERS.shareWith,
      statusFilter: constants.DEFAULT_FILTERS.statusFilter,
      tags: constants.DEFAULT_FILTERS.tags,
      usersRoleFilter: constants.DEFAULT_FILTERS.usersRoleFilter,
    })
  );
}

export function anyAboveElementHasFocus() {
  const muiModal = document.querySelector('.MuiDialog-container');
  const inputs = Array.from(document.querySelectorAll('input'));
  const muiDropdowns = Array.from(document.querySelectorAll('.Mui-focused'));

  if (muiModal !== null) return true;
  if (inputs.some((input) => document.activeElement === input)) return true;
  if (muiDropdowns?.length > 0) return true;

  return false;
}

/**
 * Generates a UUID (Universally Unique Identifier).
 *
 * @return {string} The generated UUID.
 */
export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Generates a hashed representation of the current window's location origin.
 *
 * This method encodes the origin of the current window location as bytes,
 * computes the hash of these bytes using the getHashFromBytes function,
 * and then returns the hash in uppercase.
 *
 * @return {Promise<string>} A promise that resolves to the hashed origin in uppercase.
 */
export async function getLocationOriginHash() {
  const encoder = new TextEncoder();
  const data = encoder.encode(window.location.origin);
  const hash = await getHashFromBytes(data, true);
  return hash.toUpperCase();
}
